import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface UserDetailsUserOptions {
  translateTag: string,
  path: string,
  value?: any
}

@Injectable({
  providedIn: 'root'
})
export class UserDetailsUserOptionsConfigService {
  protected defaultOptions: UserDetailsUserOptions[] = [
    { translateTag: 'ACTIVE', path: 'active' },
    { translateTag: 'FORCE_CHANGE_PASSWORD', path: 'forceChangePassword' },
    { translateTag: 'BLOCK_USER_ORDERING', path: 'extra.blockUserOrdering' },
    { translateTag: 'HIDE_PRICES_FOR_USER', path: 'extra.hidePricesForUser' }
  ];

  public getUserDetailsUserOptions(): Observable<UserDetailsUserOptions[]> {
    return of(this.defaultOptions);
  }
}
